import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

const MockChart = ({ title, type = 'line', height = 300 }) => {
  const generateRandomData = () => {
    return Array.from({ length: 12 }, () => Math.floor(Math.random() * 100));
  };

  const data = generateRandomData();
  const maxValue = Math.max(...data);

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Box sx={{ height: height, display: 'flex', alignItems: 'end', gap: 1, p: 2 }}>
          {type === 'bar' ? (
            data.map((value, index) => (
              <Box
                key={index}
                sx={{
                  height: `${(value / maxValue) * 100}%`,
                  width: '100%',
                  backgroundColor: 'primary.main',
                  opacity: 0.7,
                  borderRadius: '4px 4px 0 0',
                  minHeight: '4px'
                }}
              />
            ))
          ) : (
            <svg width="100%" height="100%" viewBox="0 0 300 200">
              <polyline
                fill="none"
                stroke="#3B82F6"
                strokeWidth="3"
                points={data.map((value, index) =>
                  `${(index / (data.length - 1)) * 300},${200 - (value / maxValue) * 180}`
                ).join(' ')}
              />
              {data.map((value, index) => (
                <circle
                  key={index}
                  cx={(index / (data.length - 1)) * 300}
                  cy={200 - (value / maxValue) * 180}
                  r="4"
                  fill="#3B82F6"
                />
              ))}
            </svg>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};


export default MockChart;
